import "./module/userAgentChecker.min.js";
import "./module/plugin.js";
import "./module/modal-multi.js";

import objectFitImages from 'object-fit-images';
objectFitImages();

import Swiper from 'swiper/bundle';
var swiper = new Swiper('.mv__innerSlider', {
    centeredSlides: true,
    effect: 'fade',
    speed: 4000,
    loop: true,
    simulateTouch: false,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    }
});

var puddingSlider = new Swiper('.puddingSlider', {
    slidesPerView: "auto",
    //spaceBetween: 60,
    speed: 900,
    loop: true,
    //simulateTouch: false,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

var itemSlider = new Swiper('.itemSlider', {
    slidesPerView: "auto",
    //spaceBetween: 60,
    speed: 900,
    loop: true,
    //simulateTouch: false,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

import Rellax from 'rellax';
var rellax = new Rellax('.parallax', {
    speed: 3,
    center: true,
    wrapper: null,
    //round: true,
    vertical: true,
    horizontal: false
});

if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('Android') > 0) {
    rellax.destroy();
}

import ScrollMagic from 'scrollmagic';

class ScrollFade {
    constructor() {
        this.ANIMATION_CLASS = 'is-fire';

        let $section = document.querySelectorAll('.js-scroll:not(.is-fire)');
        if($section.length === null) {
            return;
        }
        let controller = new ScrollMagic.Controller();
        for(let i = 0; i < $section.length; i++) {
            let scene = new ScrollMagic.Scene({
                triggerElement: $section[i],
                triggerHook: 'onEnter',
                reverse: false,
                offset: 100
            })
                .addTo(controller);
            scene.on('enter', ()=>{
                $section[i].classList.add(this.ANIMATION_CLASS);
            });
            scene.on('end', ()=>{
                scene.destroy(true);
            });
        }
    }
}

new ScrollFade();